import axios from 'axios';

const Api = axios.create({baseURL: 'https://api.consorciolvf.com.br'});

export default Api;